import React, { forwardRef } from "react"
import styled from "styled-components"
import concatWithSpaces from "../Functions/concatWithSpaces"

export interface IInputProps extends React.ComponentProps<"input"> {
	/**
	 * Sets container width to 100%
	 */
	wide?: boolean
}

const Input = forwardRef<HTMLInputElement, IInputProps>(
	({ wide = false, readOnly = false, autoComplete, style, className, ...props }, ref) => {
		const isFirefox = navigator.userAgent.indexOf("Firefox") !== -1
		return (
			<CustomInput
				{...props}
				className={concatWithSpaces(
					wide ? "w-full" : " w-3/5",
					readOnly ? "opacity-50" : "",
					readOnly ? "disable-pointer-event" : "",
					props?.type === "password" && !isFirefox ? "hide-input-char" : "",
					className
				)}
				style={{
					...style,
				}}
				// Search is the only one that does't give input suggestions.
				// Thus "hide-input-mask" class is added
				type={props?.type === "password" ? (isFirefox ? "password" : "serach") : ""}
				ref={ref}
				readOnly={readOnly}
			/>
		)
	}
)

export default Input

const CustomInput = styled.input`
	height: 38px;
	padding: 0 16px;
	background-color: var(--white);
	outline-color: var(--blue);
	border-radius: 5px;
	border: 1px solid var(--gray-c2);

	// Text
	color: inherit;
	font-family: inherit;
	font-size: 14px;
	font-weight: 400;
	line-height: 1.6;
	text-transform: none;
	word-wrap: normal;

	// Animation
	transition: 0.2s var(--default-slide-transition-fn);
	transition-property: border-color;
`
